__turbopack_context__.v({
  "content": "ContentPanelSkeletonLoader-module__bPVRYa__content",
  "grid": "ContentPanelSkeletonLoader-module__bPVRYa__grid",
  "header": "ContentPanelSkeletonLoader-module__bPVRYa__header",
  "left": "ContentPanelSkeletonLoader-module__bPVRYa__left",
  "right": "ContentPanelSkeletonLoader-module__bPVRYa__right",
});
